"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buy_third_party_component_1 = require("./buy-third-party/buy-third-party.component");
var buy_baner_component_1 = require("./buy-baner/buy-baner.component");
var AdvWithUs_component_1 = require("./AdvWithUs/AdvWithUs.component");
var router_1 = require("@angular/router");
var home_component_1 = require("./app_mobile/views/home/home.component");
var login_component_1 = require("./app_mobile/views/login/login.component");
var mobile_auth_guard_guard_1 = require("./app_mobile/components/guards/mobile-auth-guard.guard");
var registration_component_1 = require("./app_mobile/views/registration/registration.component");
var account_component_1 = require("./app_mobile/views/account/account.component");
var search_component_1 = require("./app_mobile/views/search/search.component");
var results_component_1 = require("./app_mobile/views/results/results.component");
var advertisement_component_1 = require("./app_mobile/views/advertisement/advertisement.component");
var conversation_component_1 = require("./app_mobile/views/conversation/conversation.component");
var subscribtion_component_1 = require("./app_mobile/views/subscribtion/subscribtion.component");
var subscription_information_component_1 = require("./app_mobile/views/subscription-information/subscription-information.component");
var subscription_confirm_component_1 = require("./app_mobile/views/subscription-confirm/subscription-confirm.component");
var user_advertisements_component_1 = require("./app_mobile/views/user-advertisements/user-advertisements.component");
var advertisement_edit_component_1 = require("./app_mobile/views/advertisement-edit/advertisement-edit.component");
var non_demo_ads_component_1 = require("./app_mobile/views/non-demo-ads/non-demo-ads.component");
var route_search_results_component_1 = require("./app_mobile/components/route-search-results/route-search-results.component");
var AdWritter_component_1 = require("./app_mobile/views/AdWritter/AdWritter.component");
var buy_third_party_component_2 = require("./app_mobile/views/buy-third-party/buy-third-party.component");
var page_not_found_component_1 = require("./Pages/page-not-found/page-not-found.component");
var over18_guard_guard_1 = require("./Guards/over18-guard.guard");
var help_and_faq_component_1 = require("./Cms/help-and-faq/help-and-faq.component");
var term_of_use_component_1 = require("./Cms/term-of-use/term-of-use.component");
var privacy_policy_component_1 = require("./Cms/privacy-policy/privacy-policy.component");
var dating_tips_component_1 = require("./Cms/dating-tips/dating-tips.component");
var advertise_with_us_component_1 = require("./Cms/advertise-with-us/advertise-with-us.component");
var compare_versions_component_1 = require("./Cms/compare-versions/compare-versions.component");
var compare_versions_component_2 = require("./app_mobile/components/compare-versions/compare-versions.component");
var auth_guard_guard_1 = require("./Guards/auth-guard.guard");
var about_us_component_1 = require("./Cms/about-us/about-us.component");
var contact_us_component_1 = require("./Cms/contact-us/contact-us.component");
var empty_page_component_1 = require("./Pages/empty-page/empty-page.component");
var fetch_data_component_1 = require("./fetch-data/fetch-data.component");
var counter_component_1 = require("./counter/counter.component");
var adv_edit_component_1 = require("./Adveristments/adv-edit/adv-edit.component");
var adv_manage_component_1 = require("./Adveristments/adv-manage/adv-manage.component");
var reset_password_holder_component_1 = require("./User/reset-password-holder/reset-password-holder.component");
var new_password_holder_component_1 = require("./User/new-password-holder/new-password-holder.component");
var validate_phone_holder_component_1 = require("./User/validate-phone-holder/validate-phone-holder.component");
var validate_email_component_1 = require("./User/validate-email/validate-email.component");
var registration_success_component_1 = require("./User/registration-success/registration-success.component");
var registration_holder_component_1 = require("./User/registration-holder/registration-holder.component");
var conv_list_component_1 = require("./Conversations/conv-list/conv-list.component");
var AdWritter_component_2 = require("./AdWritter/AdWritter.component");
var adv_user_advertisements_component_1 = require("./Adveristments/adv-user-advertisements/adv-user-advertisements.component");
var adv_user_messages_component_1 = require("./Adveristments/adv-user-messages/adv-user-messages.component");
var adv_detail_component_1 = require("./Adveristments/adv-detail/adv-detail.component");
var search_results_component_1 = require("./Adv/search-results/search-results.component");
var SubscribtionConfirm_component_1 = require("./SubscriptionConfirm/SubscribtionConfirm.component");
var main_window_component_1 = require("./main-window/main-window.component");
var subscriptionInformation_component_1 = require("./SubscriptionInformation/subscriptionInformation.component");
var subscribtion_component_2 = require("./Subscribtion/subscribtion.component");
var is_mobile_1 = require("is-mobile");
var home_component_2 = require("./home/home.component");
var adv_user_advertisements_non_demo_component_1 = require("./Adveristments/adv-user-advertisements-non-demo/adv-user-advertisements-non-demo.component");
var route_search_results_component_2 = require("./Adv/route-search-results/route-search-results.component");
var searchroute_service_1 = require("./Services/searchroute.service");
var action_guard_1 = require("./Guards/action.guard");
function urlMatcher(segments, group, route) {
    return matchHelper(segments, searchroute_service_1.RegexSearchList);
}
exports.urlMatcher = urlMatcher;
function urlCategoryMatcher(segments, group, route) {
    return matchHelper(segments, searchroute_service_1.RegexCategory);
}
exports.urlCategoryMatcher = urlCategoryMatcher;
function urlCityMatcher(segments, group, route) {
    return matchHelper(segments, searchroute_service_1.RegexCity);
}
exports.urlCityMatcher = urlCityMatcher;
function urlSearchResultsMatcher(segments, group, route) {
    return matchHelper(segments, searchroute_service_1.RegexSearchResults);
}
exports.urlSearchResultsMatcher = urlSearchResultsMatcher;
var matchHelper = function (segments, regExpresion) {
    var regex = new RegExp(regExpresion, "gi");
    var regexMatch = regex.exec(segments[0].path);
    if (regexMatch != null && regexMatch.groups != null) {
        var posParams_1 = {};
        Object.keys(regexMatch.groups).forEach(function (key) {
            posParams_1[key] = new router_1.UrlSegment(regexMatch.groups[key], {});
        });
        return {
            consumed: segments,
            posParams: posParams_1
        };
    }
    return null;
};
var ɵ0 = matchHelper;
exports.ɵ0 = ɵ0;
var ɵ1 = { animation: "main" }, ɵ2 = { animation: "main" }, ɵ3 = { animation: "main" }, ɵ4 = { animation: "main" }, ɵ5 = { animation: "main" }, ɵ6 = { animation: "main" }, ɵ7 = { animation: "main" }, ɵ8 = { animation: "main" }, ɵ9 = { animation: "main" }, ɵ10 = { animation: "main" }, ɵ11 = { animation: "main" }, ɵ12 = { animation: "main" }, ɵ13 = { animation: "main" }, ɵ14 = { animation: "register" }, ɵ15 = { animation: "registration-success" }, ɵ16 = { animation: "validate-email" }, ɵ17 = { animation: "validate-phone" }, ɵ18 = { animation: "new-password" }, ɵ19 = { animation: "reset-password" }, ɵ20 = { animation: "adv-edit" }, ɵ21 = { animation: "adv-manage" }, ɵ22 = { animation: "adv-create" }, ɵ23 = { animation: "adv-with-us" }, ɵ24 = { animation: "buy-baner" }, ɵ25 = { animation: "buy-third-party", isMobile: false }, ɵ26 = { animation: "counter" }, ɵ27 = { animation: "fetch-data" }, ɵ28 = { animation: "empty" }, ɵ29 = { animation: "main" }, ɵ30 = { animation: "main" }, ɵ31 = { animation: "main" }, ɵ32 = { animation: "main" }, ɵ33 = { animation: "main" }, ɵ34 = { animation: "main" }, ɵ35 = { animation: "main" }, ɵ36 = { animation: "main" };
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
exports.ɵ3 = ɵ3;
exports.ɵ4 = ɵ4;
exports.ɵ5 = ɵ5;
exports.ɵ6 = ɵ6;
exports.ɵ7 = ɵ7;
exports.ɵ8 = ɵ8;
exports.ɵ9 = ɵ9;
exports.ɵ10 = ɵ10;
exports.ɵ11 = ɵ11;
exports.ɵ12 = ɵ12;
exports.ɵ13 = ɵ13;
exports.ɵ14 = ɵ14;
exports.ɵ15 = ɵ15;
exports.ɵ16 = ɵ16;
exports.ɵ17 = ɵ17;
exports.ɵ18 = ɵ18;
exports.ɵ19 = ɵ19;
exports.ɵ20 = ɵ20;
exports.ɵ21 = ɵ21;
exports.ɵ22 = ɵ22;
exports.ɵ23 = ɵ23;
exports.ɵ24 = ɵ24;
exports.ɵ25 = ɵ25;
exports.ɵ26 = ɵ26;
exports.ɵ27 = ɵ27;
exports.ɵ28 = ɵ28;
exports.ɵ29 = ɵ29;
exports.ɵ30 = ɵ30;
exports.ɵ31 = ɵ31;
exports.ɵ32 = ɵ32;
exports.ɵ33 = ɵ33;
exports.ɵ34 = ɵ34;
exports.ɵ35 = ɵ35;
exports.ɵ36 = ɵ36;
var desktopRoutes = [
    {
        path: "",
        component: home_component_2.HomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, action_guard_1.ActionGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "city/:cityId",
        component: home_component_2.HomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "subscription",
        component: subscribtion_component_2.SubscribtionComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "subscription-information",
        component: subscriptionInformation_component_1.SubscriptionInformationComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "subscription-confirm",
        component: SubscribtionConfirm_component_1.SubscribtionConfirmComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "main",
        component: main_window_component_1.MainWindowComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ1,
        runGuardsAndResolvers: "always"
    },
    {
        path: "search-results",
        component: search_results_component_1.SearchResultsComponent,
        pathMatch: "full",
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ2,
        runGuardsAndResolvers: "always",
    },
    {
        component: search_results_component_1.SearchResultsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ3,
        runGuardsAndResolvers: "always",
        matcher: urlSearchResultsMatcher
    },
    {
        path: "search-results/:casualDating/:relationShip/:withPicture/:state/:city",
        component: search_results_component_1.SearchResultsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ4,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-detail/:code/:locationData",
        component: adv_detail_component_1.AdvDetailComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ5,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-detail/:code/c/:conversationKey",
        component: adv_detail_component_1.AdvDetailComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ6,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-detail/:code",
        component: adv_detail_component_1.AdvDetailComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ7,
        runGuardsAndResolvers: "always"
    },
    {
        path: "messages",
        component: adv_user_messages_component_1.AdvUserMessagesComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ8,
        runGuardsAndResolvers: "always"
    },
    {
        path: "my-ads",
        component: adv_user_advertisements_component_1.AdvUserAdvertisementsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ9,
        runGuardsAndResolvers: "always"
    },
    {
        path: "non-demo-ads",
        component: adv_user_advertisements_non_demo_component_1.AdvUserAdvertisementsNonDemoComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ10,
        runGuardsAndResolvers: "always"
    },
    {
        path: "ad-writter",
        component: AdWritter_component_2.AdWritterComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ11,
        runGuardsAndResolvers: "always"
    },
    {
        path: "conversations",
        component: conv_list_component_1.ConversationsListComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ12,
        runGuardsAndResolvers: "always"
    },
    {
        path: "conversations/:id",
        component: conv_list_component_1.ConversationsListComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ13,
        runGuardsAndResolvers: "always"
    },
    {
        path: "register",
        component: registration_holder_component_1.RegistrationHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ14,
        runGuardsAndResolvers: "always"
    },
    {
        path: "registration-success",
        component: registration_success_component_1.RegistrationSuccessComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ15,
        runGuardsAndResolvers: "always"
    },
    {
        path: "validate-email/:code",
        component: validate_email_component_1.ValidateEmailComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ16
    },
    {
        path: "validate-phone/:user_data",
        component: validate_phone_holder_component_1.ValidatePhoneHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ17
    },
    {
        path: "new-password/:code",
        component: new_password_holder_component_1.NewPasswordHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ18
    },
    {
        path: "reset-password",
        component: reset_password_holder_component_1.ResetPasswordHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ19
    },
    {
        path: "adv-edit/:id",
        component: adv_edit_component_1.AdvEditComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ20,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-manage/:manage-id",
        component: adv_manage_component_1.AdvManageComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ21,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-create",
        component: adv_edit_component_1.AdvEditComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ22,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-with-us",
        component: AdvWithUs_component_1.AdvWithUsComponent,
        data: ɵ23,
        runGuardsAndResolvers: "always"
    },
    {
        path: "buy-baner",
        component: buy_baner_component_1.BuyBanerComponent,
        data: ɵ24,
        runGuardsAndResolvers: "always"
    },
    {
        path: "buy-third-party",
        component: buy_third_party_component_1.BuyThirdPartyComponent,
        data: ɵ25,
        runGuardsAndResolvers: "always"
    },
    //NewPasswordComponent
    //ValidateEmailComponent
    {
        path: "counter",
        component: counter_component_1.CounterComponent,
        canActivate: [auth_guard_guard_1.AuthGuard, over18_guard_guard_1.Over18Guard],
        data: ɵ26,
        runGuardsAndResolvers: "always"
    },
    {
        path: "fetch-data",
        component: fetch_data_component_1.FetchDataComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ27,
        runGuardsAndResolvers: "always"
    },
    {
        path: "empty",
        component: empty_page_component_1.EmptyPageComponent,
        data: ɵ28
    },
    /////CMS ITEMS
    {
        path: "contact-us",
        component: contact_us_component_1.ContactUsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ29,
        runGuardsAndResolvers: "always"
    },
    {
        path: "about-us",
        component: about_us_component_1.AboutUsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ30,
        runGuardsAndResolvers: "always"
    },
    {
        path: "compare-versions",
        component: compare_versions_component_1.CompareVersionsPageComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ31,
        runGuardsAndResolvers: "always"
    },
    {
        path: "advertise-with-us",
        component: advertise_with_us_component_1.AdvertiseWithUsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ32,
        runGuardsAndResolvers: "always"
    },
    {
        path: "dating-tips",
        component: dating_tips_component_1.DatingTipsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ33,
        runGuardsAndResolvers: "always"
    },
    {
        path: "privacy-policy",
        component: privacy_policy_component_1.PrivacyPolicyComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ34,
        runGuardsAndResolvers: "always"
    },
    {
        path: "terms-of-use",
        component: term_of_use_component_1.TermOfUseComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ35,
        runGuardsAndResolvers: "always"
    },
    {
        path: "help-and-faq",
        component: help_and_faq_component_1.HelpAndFaqComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ36,
        runGuardsAndResolvers: "always"
    },
    {
        component: route_search_results_component_2.RouteSeachResults,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlMatcher
    },
    {
        component: home_component_2.HomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlCategoryMatcher
    },
    {
        component: home_component_2.HomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlCityMatcher
    },
    { path: "**", component: page_not_found_component_1.PageNotFoundComponent }
];
var ɵ37 = { animation: "registration-success" }, ɵ38 = { animation: "validate-email" }, ɵ39 = { animation: "validate-phone" }, ɵ40 = { animation: "new-password" }, ɵ41 = { animation: "reset-password" }, ɵ42 = { animation: "main" }, ɵ43 = { animation: "main" }, ɵ44 = { animation: "main" }, ɵ45 = { animation: "main" }, ɵ46 = { animation: "adv-edit" }, ɵ47 = { animation: "adv-create" }, ɵ48 = { animation: "main" }, ɵ49 = { animation: "main" }, ɵ50 = { animation: "main" }, ɵ51 = { animation: "adv-with-us" }, ɵ52 = { animation: "buy-baner" }, ɵ53 = { animation: "buy-third-party" }, ɵ54 = { animation: "reset-password" };
exports.ɵ37 = ɵ37;
exports.ɵ38 = ɵ38;
exports.ɵ39 = ɵ39;
exports.ɵ40 = ɵ40;
exports.ɵ41 = ɵ41;
exports.ɵ42 = ɵ42;
exports.ɵ43 = ɵ43;
exports.ɵ44 = ɵ44;
exports.ɵ45 = ɵ45;
exports.ɵ46 = ɵ46;
exports.ɵ47 = ɵ47;
exports.ɵ48 = ɵ48;
exports.ɵ49 = ɵ49;
exports.ɵ50 = ɵ50;
exports.ɵ51 = ɵ51;
exports.ɵ52 = ɵ52;
exports.ɵ53 = ɵ53;
exports.ɵ54 = ɵ54;
var mobileRoutes = [
    {
        path: '',
        component: home_component_1.MobileHomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'login',
        component: login_component_1.LoginComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'register',
        component: registration_component_1.RegistrationComponent,
        //loadChildren: () => import('./app_mobile/views/registration/registration.component').then(m => m.RegistrationComponent),
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: "registration-success",
        component: registration_success_component_1.RegistrationSuccessComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ37,
        runGuardsAndResolvers: "always"
    },
    {
        path: "validate-email/:code",
        component: validate_email_component_1.ValidateEmailComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ38
    },
    {
        path: "validate-phone/:user_data",
        component: validate_phone_holder_component_1.ValidatePhoneHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ39
    },
    {
        path: "new-password/:code",
        component: new_password_holder_component_1.NewPasswordHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ40
    },
    {
        path: "reset-password",
        component: reset_password_holder_component_1.ResetPasswordHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ41
    },
    {
        path: 'account',
        component: account_component_1.AccountComponent,
        //loadChildren: () => import('./app_mobile/views/account/account.component').then(m => m.AccountComponent),
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'search',
        component: search_component_1.SearchComponent,
        //loadChildren: () => import('./app_mobile/views/search/search.component').then(m => m.SearchComponent),
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: "search-results",
        component: results_component_1.ResultsComponent,
        pathMatch: "full",
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ42,
        runGuardsAndResolvers: "always"
    },
    {
        path: "search-results/:casualDating/:relationShip/:withPicture/:state/:city",
        component: results_component_1.ResultsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ43,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-detail/:code/:locationData",
        component: advertisement_component_1.AdvertisementComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ44,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-detail/:code/c/:conversationKey",
        component: advertisement_component_1.AdvertisementComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ45,
        runGuardsAndResolvers: "always"
    },
    {
        path: 'adv-detail/:code',
        component: advertisement_component_1.AdvertisementComponent,
        //loadChildren: () => import('./app_mobile/views/advertisement/advertisement.component').then(m => m.AdvertisementComponent),
        canActivate: [over18_guard_guard_1.Over18Guard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'conversations',
        component: conversation_component_1.ConversationComponent,
        //loadChildren: () => import('./app_mobile/views/conversation/conversation.component').then(m => m.ConversationComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'conversations/:id',
        component: conversation_component_1.ConversationComponent,
        //loadChildren: () => import('./app_mobile/views/conversation/conversation.component').then(m => m.ConversationComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'subscription',
        component: subscribtion_component_1.SubscribtionComponent,
        //loadChildren: () => import('./app_mobile/views/subscribtion/subscribtion.component').then(m => m.SubscribtionComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: "subscription-information",
        component: subscription_information_component_1.SubscriptionInformationComponent,
        //loadChildren: () => import('./app_mobile/views/subscription-information/subscription-information.component').then(m => m.SubscriptionInformationComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: "subscription-confirm",
        component: subscription_confirm_component_1.SubscribtionConfirmComponent,
        //loadChildren: () => import('./app_mobile/views/subscription-confirm/subscription-confirm.component').then(m => m.SubscribtionConfirmComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: "full",
        runGuardsAndResolvers: "always"
    },
    {
        path: 'my-ads',
        component: user_advertisements_component_1.UserAdvertisementsComponent,
        //loadChildren: () => import('./app_mobile/views/user-advertisements/user-advertisements.component').then(m => m.UserAdvertisementsComponent),
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        pathMatch: 'full',
        runGuardsAndResolvers: 'always'
    },
    {
        path: "adv-edit/:id",
        component: advertisement_edit_component_1.AdvEditComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ46,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-create",
        component: advertisement_edit_component_1.AdvEditComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ47,
        runGuardsAndResolvers: "always"
    },
    {
        path: "compare-versions",
        component: compare_versions_component_2.MobileCompareVersionsPageComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, mobile_auth_guard_guard_1.MobileAuthGuard],
        data: ɵ48,
        runGuardsAndResolvers: "always"
    },
    {
        path: "non-demo-ads",
        component: non_demo_ads_component_1.NonDemoAdsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ49,
        runGuardsAndResolvers: "always"
    },
    {
        path: "ad-writter",
        component: AdWritter_component_1.MobileAdWritterComponent,
        canActivate: [over18_guard_guard_1.Over18Guard, auth_guard_guard_1.AuthGuard],
        data: ɵ50,
        runGuardsAndResolvers: "always"
    },
    {
        path: "adv-with-us",
        component: AdvWithUs_component_1.AdvWithUsComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ51,
        runGuardsAndResolvers: "always"
    },
    {
        path: "buy-baner",
        component: buy_baner_component_1.BuyBanerComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ52,
        runGuardsAndResolvers: "always"
    },
    {
        path: "buy-third-party",
        component: buy_third_party_component_2.MobileBuyThirdPartyComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ53,
        runGuardsAndResolvers: "always"
    },
    {
        path: "reset-password",
        component: reset_password_holder_component_1.ResetPasswordHolderComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        data: ɵ54
    },
    {
        component: route_search_results_component_1.RouteSeachResults,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlMatcher
    },
    {
        component: home_component_1.MobileHomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlCategoryMatcher
    },
    {
        component: home_component_1.MobileHomeComponent,
        canActivate: [over18_guard_guard_1.Over18Guard],
        runGuardsAndResolvers: "always",
        matcher: urlCityMatcher
    },
    { path: "**", component: page_not_found_component_1.PageNotFoundComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule(router) {
        this.router = router;
        if (is_mobile_1.default()) {
            router.resetConfig(mobileRoutes);
        }
    }
    return AppRoutingModule;
}());
exports.AppRoutingModule = AppRoutingModule;
